import { useState } from 'react';
import {
  Button, TextField, Link, Grid, Typography, Divider, InputAdornment, IconButton
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FacebookLogin from '@greatsumini/react-facebook-login';
import PropTypes from 'prop-types';

import { isEmpty } from '../common/helpers';

const LoginForm = ({ onSubmit, google, facebook, irA, error }) => {
  // Cargar las claves desde el .env
  const FACEBOOK_APP = process.env.REACT_APP_FACEBOOK_APP_ID;
  
  const [data, setData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const log = e => {
    e.preventDefault();
    onSubmit(data.email, data.password);
  }

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Grid className="form" size={6} item mb={15}>
      <form onSubmit={log} noValidate>
        <Grid
          item
          container
          size={12}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        > 
          <Typography variant="h3" component="h3">
            Ingresa ahora
          </Typography>
        </Grid>
        <TextField
          className="input-login"
          error={isEmpty(error.email) ? false : true}
          required
          fullWidth
          id="email"
          label="Email"
          name="email"
          autoComplete="email"
          value={data.email}
          onChange={cambiar}
          helperText={!isEmpty(error.email) && error.email}
        />
        <TextField
          className="input-login"
          error={isEmpty(error.password) ? false : true}
          required
          fullWidth
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          id="password"
          autoComplete="current-password"
          value={data.password}
          onChange={cambiar}
          helperText={!isEmpty(error.password) && error.password}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="mostrar u ocultar contraseña"
                    onClick={() => setShowPassword((v) => !v)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        <Grid item container
          direction="row"
          size={12}
          sx={{
            alignItems: "center",
            justifyContent: "flex-end"
          }}
        >
          <Link onClick={irA("/forgot-pass")} type="button" component='button' variant='body'>
            Olvidé mi contraseña
          </Link>
        </Grid>
        <Button
          sx={{mt: 3, mb: 2}}
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
        >
          Entrar
        </Button>
        <Button
          sx={{mb: 3}}
          type="button"
          variant="contained"
          className="signup"
          onClick={irA("/signup")}
          disableElevation
          fullWidth
        >
          Crear cuenta
        </Button>
        <Grid container mt={2}>
          <Grid size={12}>
            <Divider component="div" role="presentation">
              <Typography variant="body2" color="#000000B2">
                Ingresar con:
              </Typography>
            </Divider>
          </Grid>
          <Grid item container direction="row" mt={2} spacing={3} size={12}>
            <Grid item size={6}>
              <FacebookLogin
                appId={FACEBOOK_APP}
                onSuccess={facebook}
                render={renderProps => (
                  <Button className="btn-facebook" onClick={renderProps.onClick}>
                    <img alt="facebook" width="25" src="/facebook.png"
                      style={{ margin: 10 }}
                    />
                    <Typography variant="h5">
                      Facebook
                    </Typography>
                  </Button>
                )}
              />
            </Grid>
            <Grid item size={6}>
              <Button className="btn-google" onClick={() => google()}>
                <img alt="google" width="25" src="/google.png"
                  style={{ margin: 10 }}
                /> 
                <Typography variant="h5">Google</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}

LoginForm.protoTypes = {
  onSubmit: PropTypes.func.isRequired,
  google: PropTypes.func.isRequired,
  facebook: PropTypes.func.isRequired,
  irA: PropTypes.func.isRequired,
  error: PropTypes.array,
}

export default LoginForm;